import React from "react";
import { Box, IconButton } from "@mui/material";
import PropTypes from "prop-types";

import { AddFolderIcon, AddLeafIcon, RemoveLeafIcon, CopyIcon } from "../../common/icons";  // eslint-disable-line no-unused-vars

import "./styles.less";

const RoleMenuActionButton = ({ children, onClick, disabled=false }) => {
    return (
        <IconButton
            className="role-menu-action-button"
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </IconButton>
    );
};

const RoleMenuActions = ({
    onAddFolder,
    onAddNode,
    onRemoveNode,
    onCopy, // eslint-disable-line no-unused-vars
    disabled=false
}) => {
    return (
        <Box>
            <RoleMenuActionButton onClick={onAddFolder} disabled={disabled}>
                <AddFolderIcon />
            </RoleMenuActionButton>

            <RoleMenuActionButton onClick={onAddNode} disabled={disabled}>
                <AddLeafIcon />
            </RoleMenuActionButton>

            <RoleMenuActionButton onClick={onRemoveNode} disabled={disabled}>
                <RemoveLeafIcon />
            </RoleMenuActionButton>

            {/* <RoleMenuActionButton onClick={onCopy}>
                <CopyIcon />
            </RoleMenuActionButton> */}
        </Box>
    );
};

RoleMenuActionButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

RoleMenuActions.propTypes = {
    onAddFolder: PropTypes.func,
    onAddNode: PropTypes.func,
    onRemoveNode: PropTypes.func,
    onCopy: PropTypes.func,
    disabled: PropTypes.bool
};

export default RoleMenuActions;